import { useEffect } from 'react';
import AuthenticatedLayout from '../Layouts/AuthenticatedLayout';
import ProductList from '../Components/ProductList';
import { useAuth } from "../context/AuthContext";

export default function Products() {
    const { user } = useAuth(); // Fetch authenticated user from context

    useEffect(() => {
        document.title = 'Εξοπλισμός - Coffee Roast City';
    }, []);

    return (
        <AuthenticatedLayout
            user={user}
        >
            {/* <Head title="Products" /> */}
            <ProductList />
        </AuthenticatedLayout>
    );
}
